import { html } from 'lit-element'
import LegalDialog from "./lit/legal-dialog"
import ManageCookiesDialog from './manage-cookies-dialog'
import GDPRModule from "./gdpr-module";
import LitElementBase from './lit/element-base'
import { Toast as BootstrapToast } from "bootstrap"

import "./gdpr-toast-dialog.scss"

export default class GDPRToast extends LitElementBase {

    static get DomTag() { return  'gdpr-toast'; }

    GetTranslations() {
        return {
            "Our site uses cookies": {
                "it": "Il nostro sito utilizza i cookies",
                "en": "Our site uses cookies",
            },
            "that help us and third-party partners remember you and improve your experience browsing our site. You agree to the use of all cookies or you can change your settings": {
                "it": "che aiutano noi e partner di terze parti a ricordarti e migliorare la tua esperienza di navigazione nel nostro sito. Acconsenti all'uso di tutti i cookie o puoi modificare le tue impostazioni",
                "en": "that help us and third-party partners remember you and improve your experience browsing our site. You agree to the use of all cookies or you can change your settings",
            },
            "To learn more": {
                "it": html`Per saperne di più, guarda la politica sui <a class="plain-link" @click="${() => {LegalDialog.ShowCookies(this.cookie_policy)}}">Cookie</a> e la <a class="plain-link" @click="${() => {LegalDialog.ShowPrivacy(this.privacy_policy)}}">Privacy</a> di ${this.site_name}`,
                "en": html`To learn more, see ${this.site_name} <a class="plain-link" @click="${() => {LegalDialog.ShowCookies(this.cookie_policy)}}">Cookie</a> &amp; <a class="plain-link" @click="${() => {LegalDialog.ShowPrivacy(this.privacy_policy)}}">Privacy Policies</a>`,
            },
            "Manage Cookies": {
                "it": "Gestisci cookies",
                "en": "Manage Cookies",
            },
            "Accept all": {
                "it": "Accetta tutti",
                "en": "Accept all",
            }
        }
    }

    constructor(site_name, cookie_policy, privacy_policy) {
        super();
		this.Data = {}
        this.site_name = site_name
        this.cookie_policy = cookie_policy
        this.privacy_policy = privacy_policy         
    }
    
    render(){
        return html`
            <div class="toast-container position-fixed bottom-0 p-3">
                <div class="Toast toast" role="alertdialog" data-bs-autohide="false">
                    <div class="toast-header">
                        <button type="button" class="btn-close ms-auto" @click="${() => {this.CloseDialog()}}" aria-label="Close"></button>
                    </div>
                    <div class="toast-body">
                        <p>
                            <strong>${this.Ln("Our site uses cookies")}</strong> ${this.Ln("that help us and third-party partners remember you and improve your experience browsing our site. You agree to the use of all cookies or you can change your settings")}.
                        </p>
                        <p>
                            ${this.Ln("To learn more")}.
                        </p>
                        <div class="mt-2 pt-2 border-top d-flex justify-content-end">
                            <button @click="${() => {this.ManageCookies()}}" type="button" class="btn btn-secondary">
                                ${this.Ln("Manage Cookies")}
                            </button>
                            &nbsp;
                            <button @click="${() => {this.AcceptAll()}}" type="button" class="btn btn-primary">${this.Ln("Accept all")}</button>
                        </div>
                    </div>
                </div>
            </div>`
    }

    firstUpdated() {
        super.firstUpdated()
      
        const toastEl = this.querySelector('.Toast')
        this.toast = new BootstrapToast(toastEl)
        this.toast.show()
        toastEl.addEventListener("hidden.bs.toast", () => {
            this.remove()
        })
    }

    ManageCookies() {
        let dlg = new ManageCookiesDialog();
        document.body.append(dlg)

        dlg.OnHide(res => {
            if(res == true)
                if(dlg.Data && typeof dlg.Data.AcceptLevel != "undefined"){
                    this.Data.AcceptLevel = dlg.Data.AcceptLevel;
                    this.hideCallback(true)
                    this.toast.hide()
                }
        });
    }

    AcceptAll() {
        this.AcceptLevel = 0;
        Object.keys(GDPRModule.ACCEPT_CATEGORIES).forEach((CATEGORY) => {
            this.AcceptLevel += GDPRModule.ACCEPT_TYPES[CATEGORY];
        })

        this.Data.AcceptLevel = this.AcceptLevel;
        this.hideCallback(true)
        this.toast.hide()
    }
    
    CloseDialog() {
        this.hideCallback(false)
        this.toast.hide()
    }

    OnHide(callback) {
        this.hideCallback = callback
    }
}

GDPRToast.RegisterElement();